import React from 'react';
import styled from 'styled-components';
import {EMPHASIS} from '@forecast-it/design-system';
import {LabelledButton} from './LabelledButton';

interface Props {
	onToggleInlineStyle: (style: string) => void;
	onToggleBlockType: (blockType: string) => void;
	onInsertLink: () => void;
	activeStyles: string[];
	activeBlockType: string;
}

const Toolbar = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	border-bottom: 1px solid ${p => p.theme.sys.color.border.decorative};
	padding: 8px 12px;
`;

interface ToolbarButton {
	label: string;
	ariaLabel: string;
	action: () => void;
	isActive: boolean;
}

export function EditorToolbar({onToggleInlineStyle, onToggleBlockType, onInsertLink, activeStyles, activeBlockType}: Props) {
	const buttons: ToolbarButton[] = [
		{
			label: 'B',
			ariaLabel: 'Bold',
			action: () => onToggleInlineStyle('BOLD'),
			isActive: activeStyles.includes('BOLD'),
		},
		{
			label: 'I',
			ariaLabel: 'Italic',
			action: () => onToggleInlineStyle('ITALIC'),
			isActive: activeStyles.includes('ITALIC'),
		},
		{
			label: 'U',
			ariaLabel: 'Underline',
			action: () => onToggleInlineStyle('UNDERLINE'),
			isActive: activeStyles.includes('UNDERLINE'),
		},
		{
			label: '🔗',
			ariaLabel: 'Link',
			action: onInsertLink,
			isActive: false,
		},
		{
			label: '•',
			ariaLabel: 'Bullet list',
			action: () => onToggleBlockType('unordered-list-item'),
			isActive: activeBlockType === 'unordered-list-item',
		},
		{
			label: '1.',
			ariaLabel: 'Numbered list',
			action: () => onToggleBlockType('ordered-list-item'),
			isActive: activeBlockType === 'ordered-list-item',
		},
	];

	return (
		<Toolbar role="toolbar" aria-label="Formatting toolbar">
			{buttons.map(btn => (
				<span key={btn.ariaLabel} onMouseDown={e => e.preventDefault()}>
					<LabelledButton
						emphasis={EMPHASIS.LOW}
						label={btn.ariaLabel}
						aria-pressed={btn.isActive}
						onPress={() => btn.action()}
					>
						{btn.label}
					</LabelledButton>
				</span>
			))}
		</Toolbar>
	);
}
